import { render, staticRenderFns } from "./CheckboxAndButtonLink.vue?vue&type=template&id=2ff2ee89"
import script from "./CheckboxAndButtonLink.vue?vue&type=script&lang=js"
export * from "./CheckboxAndButtonLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports